






























































































































































































































































































































































































































































import "@/assets/js/slick.min.js";
import "@/assets/js/slick_custom1.js";
import { CarpsaleManagementEditItemRequest } from "@/common/api";
import { LANG } from "@/common/constant";
import {
  formatImageUrl,
  getAttributeByLangCamelCase,
  getAttributeByLangSnakeCase,
} from "@/common/utils";
import store from "@/store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsalePreviewComponent",
  methods: { formatImageUrl },
  components: {
    //
  },
})
export default class CarpsalePreviewComponent extends Vue {
  public item = CarpsaleManagementEditItemRequest;

  public created() {
    this.item = store.state.Store.item;
  }

  public mounted() {
    const link = document.createElement("link");
    link.setAttribute("href", "/css/slick.css");
    link.setAttribute("rel", "stylesheet");
    document.head.append(link);
  }

  public getContentByLangCamelCase(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangCamelCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangCamelCase(object, attributeName, LANG.JA);
  }

  public getContentByLangSnakeCase(object, attributeName) {
    if (this.$route.query.lang) {
      return getAttributeByLangSnakeCase(
        object,
        attributeName,
        this.$route.query.lang,
      );
    }

    return getAttributeByLangSnakeCase(object, attributeName, LANG.JA);
  }

  public translateAttribute(attributeName) {
    const currentLang = this.$route.query.lang ? this.$route.query.lang : LANG.JA;
    return this.$t(attributeName, `${currentLang}`);
  }
}
